import React from 'react';
import { useEnabledFlagList } from './hooks/useEnabledFlagList';

export type WithFeatureFlagsProps = {
  flags: string[];
};

export default function withFeatureFlags<TProps>(
  Component: React.ComponentType<TProps & WithFeatureFlagsProps>
) {
  const Decorated: React.FC<TProps> = props => {
    const flags = useEnabledFlagList();
    return <Component flags={flags} {...props} />;
  };
  Decorated.displayName = `withFeatureFlags(${
    Component.displayName || 'Component'
  })`;
  return Decorated;
}
